import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-floatingrain-import',
  templateUrl: './floatingrain-import.component.html',
  styleUrls: ['./floatingrain-import.component.css']
})
export class FloatingrainImportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
